import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { timelineQueryKey } from '@/hooks/use-timeline'
import type { ActivityLog, CreateActivityInput } from '@/types/api'

type ActivityEntityType = 'party' | 'opportunity' | 'club' | 'introduction'

export function activityQueryKey(entityType: string, entityId: string) {
  return ['activity', entityType, entityId] as const
}

export function useActivity(entityType: ActivityEntityType, entityId: string) {
  return useQuery({
    queryKey: activityQueryKey(entityType, entityId),
    queryFn: () =>
      api.get<ActivityLog[]>(`/activity?entity_type=${entityType}&entity_id=${entityId}`),
    enabled: Boolean(entityId),
  })
}

export function useCreateActivity() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateActivityInput) => api.post<ActivityLog>('/activity', input),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: activityQueryKey(vars.entity_type, vars.entity_id) })
      // Activities are one of the three sources the unified Timeline merges.
      qc.invalidateQueries({ queryKey: timelineQueryKey(vars.entity_type, vars.entity_id) })
    },
  })
}
